module.exports = __webpack_public_path__ + "static/maya-patel-4e69e6821aa09bf87b6dbf47e7b93a6a.jpg";